import React, { useEffect, useState } from 'react'
import { cloneDeep } from 'lodash'

import ListTemplate from 'components_new/templates/internal/List'

import { useListsActions } from 'redux/actions/Lists'
import { ListTable } from 'redux/reducers/Lists'
import { FileExtension } from 'utils/types'
import { useParams } from 'utils/hooks'
import PageLayout from 'components_new/templates/PageLayout'
import { useListsStore } from 'redux/hooks/Lists'
import { useSnackbar } from 'redux/hooks/Snackbar'

const ListPage = () => {
  const listsStore = useListsStore()
  const { tryExportListTable, tryGetListData, tryGetListTables } =
    useListsActions()

  const [lists, setLists] = useState<ListTable[]>([])
  const [exportActive, setExportActive] = useState<boolean>(false)
  const params = useParams<{ id: string }>()
  const id = params.id
  const snackbar = useSnackbar()

  useEffect(() => {
    if (listsStore.tables.length === 0) {
      tryGetListTables()
    }
  }, [])

  useEffect(() => {
    // Close "download list" snackbar upon success/fail
    if (snackbar.open) {
      setExportActive(false)
    }
  }, [snackbar.open])

  useEffect(() => {
    if (listsStore.tables.length > 0) {
      const tmpTables = cloneDeep(listsStore.tables)

      setLists(
        tmpTables.sort((t1, t2) => {
          // Sort so that all available tables to export appears first.
          // Then sort alphabetically

          const boolDiff = Number(t2.has_data) - Number(t1.has_data)

          if (boolDiff !== 0) {
            return boolDiff
          }

          return t1.title.toLowerCase() < t2.title.toLowerCase() ? -1 : 1
        })
      )
    }
  }, [listsStore.tables])

  const list = lists.find((list) => list.id === params.id)

  return (
    <PageLayout
      content={{ disablePadding: true, fullWidth: true }}
      variant={'feed'}
    >
      <ListTemplate
        exportListAsCsv={(queryString: string) => {
          tryExportListTable(
            id,
            list?.plural_title as string,
            FileExtension.CSV,
            queryString
          )
          setExportActive(true)
        }}
        exportListAsExcel={(queryString: string) => {
          tryExportListTable(
            id,
            list?.plural_title as string,
            FileExtension.XLSX,
            queryString
          )
          setExportActive(true)
        }}
        fetchData={(queryString: string) => tryGetListData(id, queryString)}
        preview={listsStore.preview}
        list={list}
        exporting={exportActive}
      />
    </PageLayout>
  )
}

export default ListPage
